import React, { useState } from 'react'
import styled from 'styled-components'
import { List as UnstyledList } from 'semantic-ui-react'
import Popup from 'shared/components/Popup'
import BarePopup from 'components/BarePopup'
import { NewTabLink } from 'components/NewTabLink'

const List = styled(UnstyledList)`
  &.ui.small.list {
    font-size: 14px;
  }

  i.icon {
    margin-right: 4px;
  }
`
const Value = styled.span`
  display: inline-block;
  max-width: 100%;
  color: #292929;
`
const Item = styled(List.Item)`
  position: relative;
  padding-top: 0 !important;
  line-height: 1.3125rem !important;

  > ${Value} {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
  }

  > label {
    float: left;
    max-width: 70%;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

/**
 * @param {object} props
 * @param {Item} props.item
 */
const iconClassName = (icon) =>
  /^(fas|far|fal|fat|fad|fab)\s/.test(icon) ? icon : `far fa-${icon}`

const ListItem = ({ item }) => {
  if (item.editElement) {
    return (
      <Item>
        <Popup position="top right" tooltip={item.name}>
          <label className="text-grey">
            <i className={`icon ${iconClassName(item.icon)}`} />
            {item.name}
          </label>
        </Popup>
        <Popup position="top right" tooltip={item.customTooltip || item.value}>
          <Value style={{ marginRight: 24 }}>{item.value}</Value>
        </Popup>
        <EditButtonContainer input={item.editElement} />
      </Item>
    )
  }

  return (
    <Item>
      <Popup position="top right" tooltip={item.name}>
        <label className="text-grey">
          <i className={`icon ${iconClassName(item.icon)}`} />
          {item.name}
        </label>
      </Popup>
      <Popup position="top right" tooltip={item.customTooltip || item.value}>
        <Value>
          {item.link ? (
            <NewTabLink to={item.link}>
              {item.value} <i className="icon far fa-external-link" />
            </NewTabLink>
          ) : (
            item.value
          )}
        </Value>
      </Popup>
    </Item>
  )
}

/**
 * @typedef Item
 * @property  {string} name
 * @property  {string} value
 * @property  {string} icon
 * @property  {string=} link
 * @property  {import('react').ReactElement} [editElement]
 * @property {import('react').ReactElement=} [customTooltip]
 */

/**
 * @param {object} props
 * @param {string} props.title
 * @param {Item[]} props.items
 */
export function ListItemGroup({ title, items }) {
  return (
    <React.Fragment>
      {title && <h4 className="mt0 mb2">{title}</h4>}
      <div>
        <List size="small" relaxed>
          {items.map((item, index) => {
            if (item.value) {
              return <ListItem key={index} item={item} />
            }
          })}
        </List>
      </div>
    </React.Fragment>
  )
}

/**
 * @param {object} props
 * @param {import('react').ReactElement} props.input
 * @param {import('react').CSSProperties} [props.style]
 */
function EditButtonContainer({ input, style }) {
  const [open, setOpen] = useState(false)
  function handleClose() {
    setOpen(false)
  }

  function handleOpen() {
    setOpen(true)
  }
  return (
    <BarePopup
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      style={{ background: 'white' }}
      trigger={
        <Button className="transparent-label-icon" style={style}>
          <i className="far fa-pencil icon" />
        </Button>
      }
    >
      {React.cloneElement(input, { onClose: handleClose })}
    </BarePopup>
  )
}

const Button = styled.a`
  position: absolute;
  right: 0;
  top: 0;

  &:hover {
    cursor: pointer;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ListItemGroup/index.js